// use localStorage to keep value
export const getUser = (parent = false) => {
    let name = "user";
    if (parent) {
        name = "useroriginal";
    }

    const userJson = localStorage.getItem(name);

    var user = null;
    if (userJson) {
        user = JSON.parse(userJson);
    }

    return user;
};

export const saveUser = (user, parent = false) => {
    let name = "user";
    if (parent) {
        name = "useroriginal";
    }

    // Preserve the token if it already exists in storage but not in the new object
    // This prevents overwriting the token when saving settings, bookmarks, etc.
    const existing = getUser(parent);
    if (existing && existing.token && !user.token) {
        user.token = existing.token;
    }

    localStorage.setItem(name, JSON.stringify(user));
};

export const removeUser = (parent = false) => {
    let name = "user";
    if (parent) {
        name = "useroriginal";
    }

    localStorage.removeItem(name);
};

// TOKEN LOGIC (stored within the user object)
export const getToken = (parent = false) => {
    const user = getUser(parent);
    return user?.token || null;
};

export const saveToken = (token, parent = false) => {
    const user = getUser(parent) || {};
    user.token = token;
    saveUser(user, parent);
};

export const removeToken = (parent = false) => {
    const user = getUser(parent);
    if (user) {
        delete user.token;
        saveUser(user, parent);
    }
};

export const getUserConfig = (name = null, json = false, parent = false) => {
    let config = null;
    const user = getUser(parent);

    if (user) {
        config = user?.config;
    }

    if (config) {
        if (typeof config === "string") {
            try {
                config = JSON.parse(config);
            } catch (e) {
                config = {};
            }
        }

        if (name) {
            if (Object.hasOwn(config, name)) {
                return config[name];
            } else {
                return null;
            }
        } else {
            return json ? JSON.stringify(config) : config;
        }
    } else {
        return null;
    }
};

export const setUserConfig = (name, value, parent = false) => {
    let user = getUser(parent);

    if (!user) {
        user = {};
    }

    let config = user?.config;

    if (config) {
        if (typeof config === "string") {
            try {
                config = JSON.parse(config);
            } catch (e) {
                config = {};
            }
        }
    } else {
        config = {};
    }

    config[name] = value;
    user.config = config;
    saveUser(user, parent);

    return config;
};

export const removeUserConfig = (name, parent = false) => {
    let user = getUser(parent);

    if (user) {
        let config = user?.config;

        if (config) {
            if (typeof config === "string") {
                try {
                    config = JSON.parse(config);
                } catch (e) {
                    config = {};
                }
            }

            config[name] = null;
            user.config = config;
            saveUser(user, parent);
            return config;
        }
    }

    return null;
};

export const getTablesConfig = () => {
    const tablesJson = localStorage.getItem("tables");
    if (tablesJson) {
        try {
            return JSON.parse(tablesJson);
        } catch (e) {
            return {};
        }
    }
    return {};
};

export const setTablesConfig = (tables) => {
    localStorage.setItem(
        "tables",
        typeof tables === "string" ? tables : JSON.stringify(tables)
    );
};

export const removeTablesConfig = () => {
    localStorage.removeItem("tables");
};

export const applyUserConfig = (user, i18n, setDarkMode) => {
    let config = user?.config;
    if (config) {
        if (typeof config === "string") {
            try {
                config = JSON.parse(config);
            } catch (e) {
                config = {};
            }
        }

        if (
            Object.hasOwn(config, "tables") &&
            config.tables &&
            Object.keys(config.tables).length > 0
        ) {
            const currentTables = getTablesConfig();
            const uId = user.id.toString();

            if (!currentTables[uId]) {
                currentTables[uId] = {};
            }

            Object.keys(config.tables).forEach((tableName) => {
                currentTables[uId][tableName] = config.tables[tableName];
            });

            setTablesConfig(currentTables);
        }

        let configUser = config;
        if (
            Object.hasOwn(config, "user") &&
            config.user &&
            typeof config.user === "object"
        ) {
            configUser = config.user;
        }

        if (configUser && Object.keys(configUser).length > 0) {
            if (Object.hasOwn(configUser, "language") && configUser.language) {
                i18n.changeLanguage(configUser.language);
            }

            if (Object.hasOwn(configUser, "darkmode")) {
                setDarkMode(configUser.darkmode);
            }

            user.config = configUser;
        } else {
            user.config = {};
        }
    }
};

export const hasRoles = (user, roles, all = false) => {
    if (!user) {
        return false;
    }

    let userRoleTags = [];
    if (user.roles_tags && Array.isArray(user.roles_tags)) {
        userRoleTags = user.roles_tags;
    } else if (user.roles && Array.isArray(user.roles)) {
        userRoleTags = user.roles.map((r) => r.tag);
    } else {
        return false;
    }

    const rolesToCheck = Array.isArray(roles) ? roles : [roles];

    if (all) {
        return rolesToCheck.every((role) => userRoleTags.includes(role));
    } else {
        return rolesToCheck.some((role) => userRoleTags.includes(role));
    }
};

export const hasRole = (user, role) => {
    if (!user) {
        return false;
    }

    let userRoleTags = [];
    if (user.roles_tags && Array.isArray(user.roles_tags)) {
        userRoleTags = user.roles_tags;
    } else if (user.roles && Array.isArray(user.roles)) {
        userRoleTags = user.roles.map((r) => r.tag);
    } else {
        return false;
    }

    return userRoleTags.includes(role);
};
